<template>
    <div class="template-block-card" @click.stop="handleSelect">
        <div class="template-block-card__preview" :style="{ height: previewHeight + 'px' }">
            <block-preview :block="template.block" />
        </div>
        <div class="template-block-card__body">
            <span class="template-block-card__body-text">
                <!-- <i class="fas faw mr-2 template-block-card__body-icon" :class="glyph"/> -->
                <span class="template-block-card__body-name">{{ template.name|tr }}</span>
            </span>
        </div>
    </div>
</template>

<script>
import BlockPreview from "@/components/editor/properties/components/block-preview.vue";

export default {
    name: `template-block-card`,
    components: {BlockPreview},
    props: {
        template: {type: Object, required: true},
        previewHeight: {type: [Number, String], default: 140},
        interactive: {type: Boolean, default: true}
    },
    methods: {
        handleSelect() {
            if (!this.interactive) {
                return;
            }
            this.$emit(`select`, this.template);
        }
    }
}
</script>

<style scoped>
.template-block-card {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.template-block-card__preview {
    display: grid;
    place-items: center;
    flex-shrink: 0;
    width: 100%;
    height: 100px;
    margin-inline: auto;
    padding: 0.5rem;
    border-radius: 8px;
    overflow: hidden;
    background: white;
    border: 1px solid var(--border-color);
    outline: 1px solid transparent;
    box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.15);
}

.template-block-card__body {
    padding: 0.25rem;
}

.template-block-card__body-text {
    display: -webkit-box;
    font-weight: 500;
    font-size: 0.95rem;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    overflow: hidden !important;
}
</style>
